// extracted by mini-css-extract-plugin
export default {"block":"info-block_block__G62Z7"};